
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"63","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.969 8.14a1.016 1.016 0 001.015-1.015V1.031A1.016 1.016 0 0061.97.016h-6.094a1.016 1.016 0 00-1.016 1.015v2.032H8.141V1.03A1.016 1.016 0 007.125.016H1.031A1.016 1.016 0 00.016 1.03v6.094A1.016 1.016 0 001.03 8.141h2.032v46.718H1.03a1.016 1.016 0 00-1.015 1.016v6.094a1.016 1.016 0 001.015 1.015h6.094a1.015 1.015 0 001.016-1.015v-2.032h46.718v2.032a1.016 1.016 0 001.016 1.015h6.094a1.016 1.016 0 001.015-1.015v-6.094a1.016 1.016 0 00-1.015-1.016h-2.032V8.141h2.032zM2.047 6.11V2.046h4.062v4.062H2.047zm4.062 54.843H2.047v-4.062h4.062v4.062zm48.75-5.078v2.031H8.141v-2.031a1.016 1.016 0 00-1.016-1.016H5.094V8.141h2.031a1.016 1.016 0 001.016-1.016V5.094h46.718v2.031a1.016 1.016 0 001.016 1.016h2.031v46.718h-2.031a1.016 1.016 0 00-1.016 1.016zm6.094 1.016v4.062h-4.062v-4.062h4.062zM56.891 6.109V2.047h4.062v4.062h-4.062z","fill":"#C2CAD8"}}),_c('path',{attrs:{"d":"M54.86 13.219H8.14a1.016 1.016 0 00-1.015 1.015v34.532a1.016 1.016 0 001.016 1.015h46.718a1.016 1.016 0 001.016-1.015V14.234a1.016 1.016 0 00-1.016-1.015zM9.155 47.75v-1.146l11.172-14.46L32.386 47.75H9.156zm44.688 0h-18.89l-5.512-7.132 13.61-17.614L53.845 36.97V47.75zm0-14.103l-9.988-12.924a1.016 1.016 0 00-1.607 0L28.16 38.957l-7.027-9.093a1.015 1.015 0 00-1.608 0L9.156 43.28V15.25h44.688v18.397z","fill":"#C2CAD8"}}),_c('path',{attrs:{"d":"M20.328 27.438a5.078 5.078 0 100-10.157 5.078 5.078 0 000 10.157zm0-8.125a3.047 3.047 0 110 6.094 3.047 3.047 0 010-6.095z","fill":"#C2CAD8"}})])
          )
        }
      }
    